<!--

    Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<ods-instant-search
  [fieldControl]="fieldControl"
  [searchResultItemList]="searchResultItemList"
  [label]="label"
  [placeholder]="placeholder"
  [headerText]="headerText"
  [focusOnSearchField]="focusOnSearchField"
  [showLabel]="showLabel"
  [previewSearchMinLength]="previewSearchMinLength"
  [variant]="variant"
  (searchResultsClosed)="searchResultsClosed.emit()"
  (inputClicked)="inputClicked.emit()"
  (searchQueryChanged)="searchQueryChanged.emit($event)"
  (searchQueryCleared)="searchQueryCleared.emit()"
>
  <ng-content />
</ods-instant-search>
